import { ButtonIcon, Menu, MenuItem, MenuTrigger } from '@backstage/ui';
import SettingsIcon from '@material-ui/icons/Settings';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

interface ServiceGroupActionsMenuProps {
  onUpdate: () => void;
  onDelete: () => void;
}

export const ServiceGroupActionsMenu = ({
  onUpdate,
  onDelete,
}: ServiceGroupActionsMenuProps) => {
  return (
    <MenuTrigger>
      <ButtonIcon
        variant="tertiary"
        icon={<SettingsIcon />}
        aria-label="Tooling group settings"
      />
      <Menu>
        <MenuItem
          id="update"
          iconStart={<EditIcon fontSize="small" />}
          onAction={onUpdate}
        >
          Update tooling group
        </MenuItem>
        <MenuItem
          id="delete"
          color="danger"
          iconStart={<DeleteIcon fontSize="small" />}
          onAction={onDelete}
        >
          Delete tooling group
        </MenuItem>
      </Menu>
    </MenuTrigger>
  );
};
